<div class="form-buttons">
  <a mat-raised-button (click)="back()" class="reset-button accent-button" color="accent">Cancel</a>
  &nbsp;
  <button *ngIf="!hideSubmit" class="submit-button primary-button" mat-raised-button color="primary" [disabled]="disableSubmit" (click)="openDialogSubmit()">Submit</button>
</div>
